import { render, staticRenderFns } from "./PriceListUnitRuleNotice.vue?vue&type=template&id=4af9c73e&"
import script from "./PriceListUnitRuleNotice.vue?vue&type=script&lang=js&"
export * from "./PriceListUnitRuleNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports